/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdditionalDriverInvitationRto,
  AdditionalDriverRequest,
  LocationConfigRequest,
  LocationDevelopmentState,
  LocationVehiclesRequest,
  MetaRedirectTrackingEvent,
  PartnerPrebookingRequest,
  PreBookingRequest,
  PreBookingResponse,
  PreBookingUiConfigRtoV2,
  PrebookingUiLocationConfig,
  TnCTrackingEventDto,
  VehicleCategoryData,
} from '../models/index';
import {
    AdditionalDriverInvitationRtoFromJSON,
    AdditionalDriverInvitationRtoToJSON,
    AdditionalDriverRequestFromJSON,
    AdditionalDriverRequestToJSON,
    LocationConfigRequestFromJSON,
    LocationConfigRequestToJSON,
    LocationDevelopmentStateFromJSON,
    LocationDevelopmentStateToJSON,
    LocationVehiclesRequestFromJSON,
    LocationVehiclesRequestToJSON,
    MetaRedirectTrackingEventFromJSON,
    MetaRedirectTrackingEventToJSON,
    PartnerPrebookingRequestFromJSON,
    PartnerPrebookingRequestToJSON,
    PreBookingRequestFromJSON,
    PreBookingRequestToJSON,
    PreBookingResponseFromJSON,
    PreBookingResponseToJSON,
    PreBookingUiConfigRtoV2FromJSON,
    PreBookingUiConfigRtoV2ToJSON,
    PrebookingUiLocationConfigFromJSON,
    PrebookingUiLocationConfigToJSON,
    TnCTrackingEventDtoFromJSON,
    TnCTrackingEventDtoToJSON,
    VehicleCategoryDataFromJSON,
    VehicleCategoryDataToJSON,
} from '../models/index';

export interface CreatePartnerPreBookingRequest {
    partnerPrebookingRequest: PartnerPrebookingRequest;
}

export interface CreatePreBookingRequest {
    preBookingRequest: PreBookingRequest;
}

export interface GetCategoryImageRequest {
    locationId: number;
    vehicleCategory: GetCategoryImageVehicleCategoryEnum;
}

export interface GetConfigsForUserRequest {
    locationConfigRequest: LocationConfigRequest;
}

export interface GetLocationConfigRequest {
    locationId: number;
}

export interface GetLocationVehiclesRequest {
    locationId: number;
    locationVehiclesRequest: LocationVehiclesRequest;
}

export interface HandshakeAdditionalDriverRequest {
    additionalDriverRequest: AdditionalDriverRequest;
}

export interface InvitationAdditionalDriverRequest {
    additionalDriverRequest: AdditionalDriverRequest;
}

export interface MetaRedirectTrackingRequest {
    metaRedirectTrackingEvent: MetaRedirectTrackingEvent;
}

export interface TncTrackingRequest {
    tnCTrackingEventDto: TnCTrackingEventDto;
}

/**
 * 
 */
export class ExternalControllerApi extends runtime.BaseAPI {

    /**
     * create a partner prebooking
     */
    async createPartnerPreBookingRaw(requestParameters: CreatePartnerPreBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreBookingResponse>> {
        if (requestParameters.partnerPrebookingRequest === null || requestParameters.partnerPrebookingRequest === undefined) {
            throw new runtime.RequiredError('partnerPrebookingRequest','Required parameter requestParameters.partnerPrebookingRequest was null or undefined when calling createPartnerPreBooking.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/external/prebooking/partner`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerPrebookingRequestToJSON(requestParameters.partnerPrebookingRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreBookingResponseFromJSON(jsonValue));
    }

    /**
     * create a partner prebooking
     */
    async createPartnerPreBooking(requestParameters: CreatePartnerPreBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreBookingResponse> {
        const response = await this.createPartnerPreBookingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create a prebooking
     */
    async createPreBookingRaw(requestParameters: CreatePreBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreBookingResponse>> {
        if (requestParameters.preBookingRequest === null || requestParameters.preBookingRequest === undefined) {
            throw new runtime.RequiredError('preBookingRequest','Required parameter requestParameters.preBookingRequest was null or undefined when calling createPreBooking.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/external/prebooking/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreBookingRequestToJSON(requestParameters.preBookingRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreBookingResponseFromJSON(jsonValue));
    }

    /**
     * create a prebooking
     */
    async createPreBooking(requestParameters: CreatePreBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreBookingResponse> {
        const response = await this.createPreBookingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCategoryImageRaw(requestParameters: GetCategoryImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling getCategoryImage.');
        }

        if (requestParameters.vehicleCategory === null || requestParameters.vehicleCategory === undefined) {
            throw new runtime.RequiredError('vehicleCategory','Required parameter requestParameters.vehicleCategory was null or undefined when calling getCategoryImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/external/prebooking/image/{locationId}/{vehicleCategory}.png`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))).replace(`{${"vehicleCategory"}}`, encodeURIComponent(String(requestParameters.vehicleCategory))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getCategoryImage(requestParameters: GetCategoryImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getCategoryImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getConfigsForUserRaw(requestParameters: GetConfigsForUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreBookingUiConfigRtoV2>> {
        if (requestParameters.locationConfigRequest === null || requestParameters.locationConfigRequest === undefined) {
            throw new runtime.RequiredError('locationConfigRequest','Required parameter requestParameters.locationConfigRequest was null or undefined when calling getConfigsForUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/external/prebooking/config`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LocationConfigRequestToJSON(requestParameters.locationConfigRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreBookingUiConfigRtoV2FromJSON(jsonValue));
    }

    /**
     */
    async getConfigsForUser(requestParameters: GetConfigsForUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreBookingUiConfigRtoV2> {
        const response = await this.getConfigsForUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLocationConfigRaw(requestParameters: GetLocationConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrebookingUiLocationConfig>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling getLocationConfig.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/external/prebooking/config/{locationId}`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrebookingUiLocationConfigFromJSON(jsonValue));
    }

    /**
     */
    async getLocationConfig(requestParameters: GetLocationConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrebookingUiLocationConfig> {
        const response = await this.getLocationConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLocationDevelopmentStateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LocationDevelopmentState>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/external/prebooking/config/development`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LocationDevelopmentStateFromJSON));
    }

    /**
     */
    async getLocationDevelopmentState(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LocationDevelopmentState>> {
        const response = await this.getLocationDevelopmentStateRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getLocationVehiclesRaw(requestParameters: GetLocationVehiclesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VehicleCategoryData>>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling getLocationVehicles.');
        }

        if (requestParameters.locationVehiclesRequest === null || requestParameters.locationVehiclesRequest === undefined) {
            throw new runtime.RequiredError('locationVehiclesRequest','Required parameter requestParameters.locationVehiclesRequest was null or undefined when calling getLocationVehicles.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/external/prebooking/config/{locationId}/vehicles`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LocationVehiclesRequestToJSON(requestParameters.locationVehiclesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VehicleCategoryDataFromJSON));
    }

    /**
     */
    async getLocationVehicles(requestParameters: GetLocationVehiclesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VehicleCategoryData>> {
        const response = await this.getLocationVehiclesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * handshake for additional driver
     */
    async handshakeAdditionalDriverRaw(requestParameters: HandshakeAdditionalDriverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.additionalDriverRequest === null || requestParameters.additionalDriverRequest === undefined) {
            throw new runtime.RequiredError('additionalDriverRequest','Required parameter requestParameters.additionalDriverRequest was null or undefined when calling handshakeAdditionalDriver.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/external/prebooking/additional-driver-handshake`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdditionalDriverRequestToJSON(requestParameters.additionalDriverRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * handshake for additional driver
     */
    async handshakeAdditionalDriver(requestParameters: HandshakeAdditionalDriverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.handshakeAdditionalDriverRaw(requestParameters, initOverrides);
    }

    /**
     * invitation for additional driver
     */
    async invitationAdditionalDriverRaw(requestParameters: InvitationAdditionalDriverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdditionalDriverInvitationRto>> {
        if (requestParameters.additionalDriverRequest === null || requestParameters.additionalDriverRequest === undefined) {
            throw new runtime.RequiredError('additionalDriverRequest','Required parameter requestParameters.additionalDriverRequest was null or undefined when calling invitationAdditionalDriver.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/external/prebooking/additional-driver-invitation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdditionalDriverRequestToJSON(requestParameters.additionalDriverRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdditionalDriverInvitationRtoFromJSON(jsonValue));
    }

    /**
     * invitation for additional driver
     */
    async invitationAdditionalDriver(requestParameters: InvitationAdditionalDriverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdditionalDriverInvitationRto> {
        const response = await this.invitationAdditionalDriverRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Track customer redirected from Meta, via F2M
     */
    async metaRedirectTrackingRaw(requestParameters: MetaRedirectTrackingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.metaRedirectTrackingEvent === null || requestParameters.metaRedirectTrackingEvent === undefined) {
            throw new runtime.RequiredError('metaRedirectTrackingEvent','Required parameter requestParameters.metaRedirectTrackingEvent was null or undefined when calling metaRedirectTracking.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/external/prebooking/meta/redirect`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MetaRedirectTrackingEventToJSON(requestParameters.metaRedirectTrackingEvent),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Track customer redirected from Meta, via F2M
     */
    async metaRedirectTracking(requestParameters: MetaRedirectTrackingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.metaRedirectTrackingRaw(requestParameters, initOverrides);
    }

    /**
     */
    async tncTrackingRaw(requestParameters: TncTrackingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.tnCTrackingEventDto === null || requestParameters.tnCTrackingEventDto === undefined) {
            throw new runtime.RequiredError('tnCTrackingEventDto','Required parameter requestParameters.tnCTrackingEventDto was null or undefined when calling tncTracking.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/external/prebooking/tnc-tracking`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TnCTrackingEventDtoToJSON(requestParameters.tnCTrackingEventDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async tncTracking(requestParameters: TncTrackingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.tncTrackingRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const GetCategoryImageVehicleCategoryEnum = {
    XS: 'XS',
    S: 'S',
    M: 'M',
    L: 'L',
    XSC: 'XSC',
    SC: 'SC',
    MC: 'MC',
    LC: 'LC',
    XSE: 'XSE',
    SE: 'SE',
    ME: 'ME',
    LE: 'LE',
    XL: 'XL'
} as const;
export type GetCategoryImageVehicleCategoryEnum = typeof GetCategoryImageVehicleCategoryEnum[keyof typeof GetCategoryImageVehicleCategoryEnum];
